const products = [
  {
    id: "vpn",
    name: "VPN",
    tagline: "Secure. Private. Fast.",
    description:
      "Our VPN app provides military-grade encryption to protect your internet connection on any network. Browse privately, bypass restrictions, and keep your personal data safe from prying eyes — all with a single tap.",
    features: ["256-bit AES Encryption", "No-Log Policy", "Global Server Network", "Kill Switch Protection", "Split Tunneling"],
    category: "Security",
    icon: "ri-shield-keyhole-line",
    gradient: "from-slate-800 to-slate-600",
    accentColor: "bg-slate-100 text-slate-700",
    image:
      "https://public.readdy.ai/ai/img_res/d8a9ef6567948a50a3f2cde69cae57b4.jpg",
  },
  {
    id: "cleaner",
    name: "Cleaner",
    tagline: "Clean. Fast. Optimized.",
    description:
      "Cleaner intelligently scans your iPhone or iPad to remove junk files, duplicate photos, and unnecessary data that slow down your device. Reclaim storage space and restore peak performance in minutes.",
    features: ["Duplicate Photo Finder", "Junk File Removal", "Storage Analyzer", "Contact Cleaner", "Smart Recommendations"],
    category: "Optimization",
    icon: "ri-speed-up-line",
    gradient: "from-emerald-800 to-teal-700",
    accentColor: "bg-emerald-50 text-emerald-700",
    image:
      "https://readdy.ai/api/search-image?query=iOS%20cleaner%20optimization%20app%20interface%20mockup%20on%20iPhone%2C%20bright%20clean%20design%20with%20storage%20gauge%20and%20progress%20indicators%2C%20minimalist%20utility%20app%20UI%2C%20white%20background%20with%20soft%20green%20teal%20accents%2C%20modern%20mobile%20app%20screenshot%2C%20no%20text%20overlays&width=600&height=700&seq=liwas-cleaner-product&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gray-200 mb-6">
              <span className="text-xs font-semibold tracking-widest uppercase text-gray-500">Our Products</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
              Built for iOS.<br />
              <span className="text-gray-400">Designed for You.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-900 self-start md:self-auto">
            <span className="text-white text-xs font-semibold tracking-widest uppercase">2 Applications</span>
          </div>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-8">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className="rounded-2xl overflow-hidden bg-white flex flex-col lg:flex-row"
              style={{ animation: `fadeInUp 0.7s ease ${idx * 0.15}s both` }}
            >
              {/* Image side */}
              <div
                className={`lg:w-2/5 relative overflow-hidden bg-gradient-to-br ${product.gradient} flex items-center justify-center min-h-64 lg:min-h-auto`}
              >
                <img
                  src={product.image}
                  alt={`${product.name} iOS app`}
                  className="w-48 md:w-56 h-auto object-contain object-top relative z-10 mt-8 lg:mt-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>

              {/* Content side */}
              <div className="lg:w-3/5 p-8 md:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${product.accentColor}`}>
                    <i className={`${product.icon} text-sm`} />
                    {product.category}
                  </span>
                </div>

                <h3 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-2 tracking-tight">{product.name}</h3>
                <p className="text-base font-semibold text-gray-400 mb-5 tracking-wide">{product.tagline}</p>
                <p className="text-gray-600 text-base leading-relaxed mb-8">{product.description}</p>

                {/* Features */}
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2.5 text-sm text-gray-700">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                        <i className="ri-check-line text-xs text-gray-600" />
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
